<template>
  <div id="app">
    <!-- Menú lateral -->
    <div class="menu">
      <h1 class="menu-title">Hola!!! Conoce tu boleta</h1>
      <button @click="focusSection('datosCliente')">
        <i class="icon icon-user"></i> Datos del Cliente
      </button>
      <button @click="focusSection('numeroTelefono')">
        <i class="icon icon-phone"></i> Número de Teléfono
      </button>
      <button @click="focusSection('vencimiento')">
        <i class="icon icon-calendar"></i> Vencimiento
      </button>
      <button @click="focusSection('pago')">
        <i class="icon icon-dollar"></i> Pago
      </button>
      <button @click="focusSection('movimientosAnteriores')">
        <i class="icon icon-history"></i> Movimientos
      </button>
      <button @click="focusSection('desgloseConsumo')">
        <i class="icon icon-chart"></i> Desglose
      </button>
    </div>

    <!-- Contenedor de la boleta -->
    <div class="boleta-container">
      <div class="zoom-container" :style="zoomStyle">
        <img src="@/assets/boleta-telcel.png" alt="Boleta" class="boleta-image" /> 
        <!-- <img src="https://perubi.com/wp-content/uploads/2022/04/boleta-de-pago.png" alt="Boleta" class="boleta-image" /> -->
        <div
          v-for="section in sections"
          :key="section.id"
          :id="section.id"
          class="highlight"
          :style="getHighlightStyle(section)"
        ></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      activeSection: '',
      selectedVoice: 1,
      zoomStyle: {
        transform: 'scale(1)',
        transformOrigin: 'top left',
        transition: 'transform 1s ease',
      },
      sections: [
        {
          id: 'datosCliente',
          text: 'En esta seccion se ubica el nombre del cliente, Su nombre es Francisco Ernesto Jovel Lara',
          style: {
            top: '269px',
            left: '50px',
            width: '255px',
            height: '20px',
          },
          zoomPosition: {
            x: 80,
            y: 155,
          },
        },
        {
          id: 'numeroTelefono',
          text: 'En esta seccion se ubica el Número de teléfono: Su numero de teléfono es 5 5 3 6 5 7 3 4 7 2',
          style: {
            top: '90px',
            left: '520px',
            width: '210px',
            height: '20px',
          },
          zoomPosition: {
            x: 580,
            y: 155,
          },
        },
        {
          id: 'vencimiento',
          text: 'En esta seccion se ubica el Vencimiento de la boleta, su boleta vence el 28 de Diciembre del 2024',
          style: {
            top: '138px',
            left: '520px',
            width: '210px',
            height: '20px',
          },
          zoomPosition: {
            x: 580,
            y: 210,
          },
        },
        {
          id: 'pago',
          text: 'En esta seccion se ubica el Total a pagar, su total a pagar es 1836 pesos',
          style: {
            top: '90px',
            left: '315px',
            width: '160px',
            height: '55px',
          },
          zoomPosition: {
            x: 380,
            y: 215,
          },
        },
        {
          id: 'movimientosAnteriores',
          text: 'En esta seccion se encuentran los movimientos anteriores a la facturacion actual, es decir, si arrastra un monto del mes anterior',
          style: {
            top: '400px',
            left: '50px',
            width: '700px',
            height: '120px',
          },
          zoomPosition: {
            x: 350,
            y: 700,
          },
        },
        {
          id: 'desgloseConsumo',
          text: 'En esta seccion se encuentra el desglose de los servicios que incluye el plan, como minutos de voz, datos de redes sociales incluidas en el plan, y tambien el detalle de su consumo en el mes ',
          style: {
            top: '550px',
            left: '55px',
            width: '720px',
            height: '470px',
          },
          zoomPosition: {
            x: 350,
            y: 2560,
          },
        },
      ],
    };
  },
  methods: {
    loadVoices() {
      const voices = window.speechSynthesis.getVoices();
      const spanishVoices = voices.filter((voice) => voice.lang === 'es-ES');
      if (spanishVoices.length > 0) {
        this.selectedVoice = spanishVoices[0]; // Selecciona la primera voz en español
      }
    },
    speakText(text) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'es-ES';
      if (this.selectedVoice) {
        utterance.voice = this.selectedVoice;
      }
      window.speechSynthesis.speak(utterance);
    },
    focusSection(sectionId) {
      const section = this.sections.find((sec) => sec.id === sectionId);
      if (section) {
        this.activeSection = sectionId;
        this.speakText(section.text);
        this.animateZoom(section.zoomPosition, sectionId);
      }
    },
    getHighlightStyle(section) {
      const defaultStyle = {
        position: 'absolute',
        border: '2px solid yellow',
        backgroundColor: 'rgba(255, 0, 0, 0.3)',
      };
      return { ...defaultStyle, ...section.style, display: this.activeSection === section.id ? 'block' : 'none' };
    },
    animateZoom(position) {
      const scale = 1.3; // Nivel de zoom
      this.zoomStyle = {
        transform: `scale(${scale})`,
        transformOrigin: `${position.x}px ${position.y}px`,
        transition: 'transform 1s ease',
      };

      // Mantiene el resaltado activo durante el zoom
      setTimeout(() => {
        this.zoomStyle = {
          transform: 'scale(1)',
          transformOrigin: 'top left',
          transition: 'transform 1s ease',
        };
        // Quita la selección después de finalizar el zoom
        this.activeSection = '';
      }, 7000); // Duración del zoom
    },
  },
  mounted() {
    window.speechSynthesis.onvoiceschanged = this.loadVoices;
    this.loadVoices();
  },
};
</script>


<style>

/* Importar la fuente de Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

.menu {
  position: fixed;
  left: 0;
  top: 0;
  padding: 20px;
  background-color: #ffffff;
  width: 180px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-title {
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  color: #007bff; /* Azul eléctrico */
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 1px;
}

.menu button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  color: #007bff; /* Azul eléctrico */
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.menu button:hover {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.menu button i {
  margin-right: 10px;
  font-size: 16px;
  color: #007bff; /* Azul eléctrico */
}

.boleta-container {
  margin-left: 200px;
  padding: 20px;
}

/* Iconos personalizados */
.icon {
  display: inline-block;
}

.icon-user:before {
  content: "👤";
}

.icon-phone:before {
  content: "📞";
}

.icon-calendar:before {
  content: "📅";
}

.icon-dollar:before {
  content: "💵";
}

.icon-history:before {
  content: "⏳";
}

.icon-chart:before {
  content: "📊";
}
</style>
